export const MANAGER_GROUP_NAME = {
  allgames: {
    text: 'All Games',
    textcn: '全部游戏',
  },
  allcompanies: {
    text: 'All Companies',
    textcn: '全部公司',
  },
  myfavourite: {
    text: 'My favourite',
    textcn: '我的收藏',
  },
}